import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type UiState = {
  globalLoading: boolean;
  openModals: Record<string, boolean>;
  notificationFlags: Record<string, boolean>;
};

const initialState: UiState = {
  globalLoading: false,
  openModals: {},
  notificationFlags: {},
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.globalLoading = action.payload;
    },
    setModalOpen: (
      state,
      action: PayloadAction<{ key: string; isOpen: boolean }>,
    ) => {
      state.openModals[action.payload.key] = action.payload.isOpen;
    },
    setNotificationFlag: (
      state,
      action: PayloadAction<{ key: string; value: boolean }>,
    ) => {
      state.notificationFlags[action.payload.key] = action.payload.value;
    },
    resetUiState: () => initialState,
  },
});

export const {
  resetUiState,
  setGlobalLoading,
  setModalOpen,
  setNotificationFlag,
} = uiSlice.actions;

export default uiSlice.reducer;
